var map = {
	"./bag.png": "7e8a",
	"./bag.svg": "3128",
	"./baklava.png": "ae97",
	"./baklava.svg": "6924",
	"./bohodiamond.png": "d4c0",
	"./bohodiamond.svg": "2169",
	"./broken-heart.svg": "d631",
	"./bunny.gif": "46e7",
	"./bunny.svg": "7363",
	"./burger.svg": "7c75",
	"./cake.svg": "7a59",
	"./candies.gif": "7834",
	"./candies.svg": "17ee",
	"./candycane.png": "da47",
	"./candycane.svg": "094b",
	"./car.png": "d480",
	"./car.svg": "f81a",
	"./carrot.svg": "0bb7",
	"./carrots.gif": "fc71",
	"./champagne.png": "da31",
	"./champagne.svg": "7e6a",
	"./cheers.png": "1252",
	"./cheers.svg": "cc68",
	"./chocolate-box.svg": "9f86",
	"./christmascouple.svg": "ff0c",
	"./christmashat.png": "822d",
	"./christmashat.svg": "0bc5",
	"./christmassweater.png": "ca21",
	"./christmassweater.svg": "67f0",
	"./christmastree.png": "cc57",
	"./christmastree.svg": "d38e",
	"./cocktail.png": "4bd3",
	"./cocktail.svg": "dccb",
	"./coffee.svg": "7ea3",
	"./diamond-ring.svg": "a48c",
	"./dollarcoin.png": "1193",
	"./dollarcoin.svg": "4228",
	"./donut.png": "7ef6",
	"./donut.svg": "54c9",
	"./easter.gif": "8f2c",
	"./evileyetalisman.png": "a6ee",
	"./evileyetalisman.svg": "688d",
	"./gift.svg": "c460",
	"./gold-ingot.svg": "d218",
	"./happy_easter.svg": "bce3",
	"./happy_holidays.svg": "6f44",
	"./happynewyear.png": "9a4a",
	"./happynewyear.svg": "f0b5",
	"./heart.svg": "4500",
	"./holiday_message.gif": "8a93",
	"./hookah.png": "0958",
	"./hookah.svg": "5114",
	"./hug.png": "f868",
	"./hug.svg": "4153",
	"./ice-cream.svg": "fcb6",
	"./key.png": "0661",
	"./key.svg": "c6bd",
	"./kiss.svg": "d102",
	"./lemonade.svg": "adf0",
	"./love-balloon.png": "6203",
	"./love-balloon.svg": "bbef",
	"./necklace.png": "6b61",
	"./necklace.svg": "8a49",
	"./newyear.png": "cecf",
	"./newyear.svg": "a3df",
	"./noelcouple.png": "e2b4",
	"./noelcouple.svg": "2e2f",
	"./orchid.png": "7c36",
	"./rose-bouqet.svg": "478b",
	"./rose.svg": "e33b",
	"./snowman.png": "a2c7",
	"./snowman.svg": "4031",
	"./star.png": "4c66",
	"./star.svg": "ef79",
	"./streaming_butterfly.svg": "b278",
	"./streaming_champagne.svg": "6821",
	"./streaming_dove.svg": "3dfb",
	"./streaming_flowers.svg": "fa4b",
	"./streaming_hot.svg": "da24",
	"./streaming_kupid.svg": "72ee",
	"./streaming_moto.svg": "d7b5",
	"./streaming_princess.svg": "a9a3",
	"./streaming_rabbit.svg": "97e2",
	"./streaming_rabbit_clouds.svg": "524a",
	"./tea.svg": "b3e6",
	"./teddy-bear.png": "7096",
	"./teddy-bear.svg": "41a5",
	"./turkish_delight.gif": "b263",
	"./turkish_delight.svg": "b9a7",
	"./user_photo.svg": "8c7f",
	"./user_video.svg": "6626",
	"./vd-cupids-arrow.svg": "25ae",
	"./vd-date-of-love.svg": "a49d",
	"./vd-kiss.svg": "c32e",
	"./vd-lollipop.svg": "d30d",
	"./vd-love-letter.svg": "08135",
	"./vd-love-potion.svg": "97e6",
	"./vd-lover-birds.svg": "d0f7",
	"./vd-milkshake.svg": "7931",
	"./vd-valentines-day.svg": "8cb5",
	"./wedding-ring.svg": "7e59"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2ada";